import React from 'react';

const StarRow = ({ value = 0, max = 5, size = 18 }) => {
  const rating = Math.max(0, Math.min(max, Number(value) || 0));

  return (
    <div className="fi-star-row" aria-label={`${rating} out of ${max} stars`}>
      {Array.from({ length: max }).map((_, index) => {
        const fill = Math.max(0, Math.min(1, rating - index));
        const gradientId = `fi-star-g-${size}-${index}-${Math.round(fill * 100)}`;

        return (
          <span
            key={`star-${index}`}
            className="fi-star"
            style={{ width: size, height: size }}
          >
            <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
              <defs>
                <linearGradient id={gradientId}>
                  <stop offset={`${fill * 100}%`} stopColor="#f5c518" />
                  <stop offset={`${fill * 100}%`} stopColor="#e5e7eb" />
                </linearGradient>
              </defs>
              <path
                d="M12 2.8l2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 16.7 6.6 19.6l1-6.1L3.2 9.2l6.1-.9L12 2.8z"
                fill={`url(#${gradientId})`}
              />
            </svg>
          </span>
        );
      })}
    </div>
  );
};

export default StarRow;
